gtemplate>
  <div class="cam">
    <div>
      你好，欢迎参加比赛，我们需要先确认参赛选手身份，请手持身份证，允许网页左上角打开摄像头并拍摄一张<span class="color">同时包含人脸和身份证</span> 的照片。
    </div>
    <div class="line">
      <div class="prev">
        <WebCam
          ref="webcam"
          :deviceId="deviceId"
          width="640"
          height="480"
          @cameras="onCameras"
          @camera-change="onCameraChange"
          :isFrontCam="frontCam"
        >
        </WebCam>
      </div>
      <my_button :value="'拍摄'" :inputStyle="buttonStyle" @click.native="capture"></my_button>
    </div>
    <div class="line">
      <div>
        <div class="prev">
          预览
        </div>
        <img v-if="img" :src="img" />
      </div>
      <div class="buttons">
        <my_button :value="'确认照片'" :inputStyle="buttonStyle" @click.native="next"></my_button>
        <a v-if="!clickedWait" href="javascript:void(0)" @click="wait">没有摄像头？</a>
        <span v-else>请等待一分钟，系统记录后可以继续</span>
        <a v-if="continueAnyway" href="javascript:void(0)" @click="next">点击继续>></a>
      </div>
    </div>
  </div>
</template>
<script>
import { WebCam } from 'vue-cam-vision'
import MyButton from '@/components/Button.vue';

export default {
  data () {
    return {
      captures: [],
      imgReport: [],
      frontCam: true,
      webcam: null,
      img: null,
      camera: null,
      deviceId: null,
      devices: [],
      clickedWait: false,
      continueAnyway: false,
    }
  },
  components: {
    WebCam,
    my_button: MyButton,
  },
  computed: {
    buttonStyle() {
      return {
        'border-radius': '5px',
        'margin-top': '2vw',
        'width': '8em'
      }
    },
  },
  methods: {
    wait() {
      this.clickedWait = true
      setTimeout((() => this.continueAnyway = true), 60000)
    },
    onCameras (e) {
      console.log(e)
    },
    onCameraChange (e) {
      console.log(e)
    },
    async capture () {
      this.img = await this.$refs.webcam.capture()
    },
    next () {
      if (!this.img) {
        return this.$emit('next')
      } else {
        const data = new FormData();
        data.set('image', this.img);
        this.$http.post('/api/user/image', data).then(res => {
          console.log('success')
          this.$emit('next')
        })
      }
    }
  }
}
</script>
<style scoped>
.cam {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
.line {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.buttons {
  display: flex;
  flex-direction: column;
}
.buttons a {
  font-size: 12px;
}
.prev {
  width: 640px;
  height: 480px;
  border: 1px solid black;
}
.color {
  color: #fa5151;
}
</style>
